import ozNeighborhoodsGuideBanner from './oz-neighborhoods-guide-banner.vue'

export default ozNeighborhoodsGuideBanner
